<div class="row">
    <div class="col-5 mb-3">
      <h2 class="title-list">{{ title }}</h2>
    </div>
    <div class="col btn-back text-end">
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div>
  <div
    class="fw-bold bg-white p-3 rounded-5 mb-5"
    *ngIf="permissionsService.createPermission"
  >
    <!-- Primera fila -->
    <div class="row mt-3">
      <div class="col">
        <label for="information" class="labelInformation">{{
          information
        }}</label>
      </div>
    </div>
  
    <!-- Segunda fila -->
    <div class="row mt-3">
      <div class="col-6">
        <label for="customerName">Role Name<span class="required">*</span></label>
        <input
          type="text"
          class="form-control input-label"
          (input)="checkFields()"
          [(ngModel)]="roleName"
        />
      </div>
    </div>
  
    
      <!-- cuarta fila -->
      <div class="row mt-3">
        <div class="col">
          <input
            type="checkbox"
            class="checkbox"
            id="active"
            name="active"
            [(ngModel)]="isActive"
          />
          <label for="active" class="m-2">Active</label>
        </div>
      </div>
  
    <!-- Cuarta fila -->
    <div class="row mt-3">
      <div class="col"></div>
      <!-- Columna vacía que empuja el botón hacia la derecha -->
      <div class="col-2 text-end">
        <button
          class="btn btn-primary w-100"
          [disabled]="!fieldsCompleted"
          (click)="createRole()"
        >
          Create Role
        </button>
      </div>
    </div>
  </div>
  